export default "__VITE_ASSET__Ct0hev62__"